module.exports = __webpack_public_path__ + "img/tec9.24160c2f.svg";